<template>
	<v-btn dark depressed outlined color="#5C8DF5" v-bind="$attrs" v-on="$listeners" class="dashed-button">
		<slot />
	</v-btn>
</template>

<script>
export default {
	name: 'DashedButton',
};
</script>

<style scoped lang="scss">
.dashed-button {
	font-size: 14px;
	cursor: pointer;
	text-align: center;
	color: var(--primary-color);

	height: 38px;
	border-radius: 6px;
	background: var(--bg-color);
	border: 1px dashed var(--primary-color);
	&:hover {
		border: 1px solid var(--primary-color);
	}
}
</style>
